import { Divider, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { EnrichedAnchorTag } from '@/shared';

import BillingAddress from '../99-BillingAddress';

const BillingPortal: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();

    return (
        <>
            <Divider style={{ margin: '1rem 0' }} />
            <div style={{ marginBottom: '1rem' }}>
                <Typography.Title level={5}>Manage your Plan</Typography.Title>
                <span style={{ color: token.colorTextTertiary }}>
                    We use <EnrichedAnchorTag label={<>Stripe</>} url='https://stripe.com' /> for managing your billing
                    & plans.
                </span>
            </div>
            {/* <CreditCardVisual
                cardholderName={creditCardData?.billing_details?.name ?? 'Name'}
                cardNumber={creditCardData?.card?.last4 ?? '1234'}
                expiry={`${creditCardData?.card?.exp_month ?? '1'}/${creditCardData?.card?.exp_year ?? '2050'}`}
                billingAddress={{
                    line1: creditCardData?.billing_details?.address?.line1,
                    line2: creditCardData?.billing_details?.address?.line2,
                    city: creditCardData?.billing_details?.address?.city,
                    state: creditCardData?.billing_details?.address?.state,
                    postalCode: creditCardData?.billing_details?.address?.postal_code,
                    country: creditCardData?.billing_details?.address?.country,
                }}
                cvc=''
            /> */}
            <BillingAddress />
        </>
    );
};

export default BillingPortal;
